import React from 'react';
import {Link} from 'react-router-dom';

import LogoBYD from './../UI/interface/logoBYD.svg'

import { CATALOGO_ROUTE} from './../config/routes';

import {ContextLoader} from './../utils/import.frames'

import Icons from './../utils/import.icons'

interface Props{
    general?: any
    intro?: any
}

interface State{
    loaded?: boolean,
    welcomed?: boolean,
    cache?: any
    cachedImages ?: boolean,
    loadedImages?: any,
    prevState?: any,
    general?: any,
    isMounted: boolean
}

class Ingreso extends React.Component <Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {
            loaded: false,
            welcomed: false,
            cache: [],
            cachedImages: false,
            loadedImages: 0,
            prevState: 0,
            isMounted: true
        }
    }

    componentDidMount() {
        const interiorE2 = window.innerWidth > 825 ? ContextLoader["Interior HATCHBACK EV"]()[0] : ContextLoader["Interior HATCHBACK EV"]()[1]
        const interiorYuan300 = window.innerWidth > 825 ? ContextLoader["Interior YUAN 300"]()[0] : ContextLoader["Interior YUAN 300"]()[1]
        const interiorYuan400 = window.innerWidth > 825 ? ContextLoader["Interior YUAN 400"]()[0] : ContextLoader["Interior YUAN 400"]()[1]
        const interiorT3 = window.innerWidth > 825 ? ContextLoader["Interior T3"]()[0] : ContextLoader["Interior T3"]()[1]
        const interiorM3 = window.innerWidth > 825 ? ContextLoader["Interior M3"]()[0] : ContextLoader["Interior M3"]()[1]
        const interiorSongPro = window.innerWidth > 825 ? ContextLoader["Interior SONG PRO"]()[0] : ContextLoader["Interior SONG PRO"]()[1]

        const intro = ContextLoader["intro"]()
        const backgrounds = ContextLoader["backgrounds"]()

        const imgs = [
            interiorE2,
            interiorYuan300,
            interiorYuan400,
            interiorT3,
            interiorM3,
            interiorSongPro,
            intro[0],
            intro[1],
            intro[2],
            intro[3],
            intro[4],
            intro[5],
            backgrounds[0],
            backgrounds[1],
            backgrounds[2],
            backgrounds[3],
            backgrounds[4],
            backgrounds[5],
        ];

        imgs.forEach((src: any) =>{
            new Promise((resolve: any, reject: any) => {

                const img = new Image()
                img.src = src

                var stateCopy = Object.assign({}, this.state)
                stateCopy.cache[src] = img
                this.setState(stateCopy)
                
                img.onload = (event) => {
                    this.setState(prevState => ({
                        loadedImages: prevState.loadedImages + 1
                    }),
                    () => {
                        if(this.state.loadedImages === imgs.length){
                            this.setState(prevState => ({
                                cachedImages: true
                            }),
                            () => {
                                this.handleCatalogoLoaded();
                            })
                        }
                    })
                }
                img.onerror = (err) => {
                    reject();
                }
            }).catch((e) => {
                console.log("[cache error]:", e);
            });
            
        })

        
    }

    componentWillUnmount(){
        this.setState({
            isMounted: false
        })
    }

    handleCatalogoLoaded = () => {
        setTimeout(function(this: any){
            this.setState({
                loaded: true
            });
            this.handleWelcomeMessage()
        }.bind(this), 2000);
        
    }

    handleWelcomeMessage = () => {
        setTimeout(function(this: any){
            this.setState({
                welcomed: true
            });
        }.bind(this), 3500);
    }

    render(){
        return(
                <div className = {!this.state.welcomed ? 'loading-page': 'loading-page swap-image'}>
                    <div className="responsive-portrait-layer">
                        <div className="layer">
                            <span className="layer-text">MEJORA TU EXPERIENCIA</span>
                            <div className="layer-imgs">
                                <img className = "layer-img" src={Icons["rotate"]} alt=''></img>
                                <img className = "layer-img" src={Icons["phone"]} alt=''></img>
                            </div>
                            
                        </div>
                        
                    </div>
                    {!this.state.loaded ?
                    
                    <div className = {!this.state.loaded ? 'loading-div fade-in':'loading-div fade-out'}>
                        <div className = 'loading-page-circle'>
                            <img src = {LogoBYD} id = "LogoBYD" alt=''/>
                            <svg className="loader-circle" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                                <circle className= 'internal-circle' cx="75" cy="75" r="70"></circle>
                            </svg>
                            <svg className="loader-circle-over" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                                <circle className= 'internal-circle-over' cx="75" cy="75" r="70"></circle>
                            </svg>
                        </div>
                        
                    </div>
                    :
                    <div className = 'welcome-div fade-in'>
                        <img src = {LogoBYD} id = "welcome-logo" alt='' />
                        <p className = 'first-text'>
                            BIENVENIDO
                        </p>
                        <p className = 'second-text'>
                            a nuestro catálogo digital
                        </p>
                        <Link
                            to={{
                                pathname: CATALOGO_ROUTE
                            }}
                            className="btn_ingreso"
                        >
                            <span>Ingresar</span>
                        </Link>
                    </div>
                    }
                </div>
        )
    }
}

export default Ingreso;